import { useCallback } from 'react';
import { useSnapPoints } from './useSnapPoints';
import { usePlaybackStateStore, PlaybackEventEmitter, PlaybackEvent, } from '@annunciate/core';
const { setPlayerIndex } = usePlaybackStateStore.getState();
export const usePlayerUtils = () => {
    const playing = usePlaybackStateStore(useCallback(state => state.content, []));
    const snapPoints = useSnapPoints();
    const onSheetChange = useCallback((index, indexRef) => {
        setPlayerIndex(index);
        indexRef.current = index;
        if (index === -1) {
            PlaybackEventEmitter.emit(PlaybackEvent.STOP);
        }
    }, []);
    const onToggleSheet = useCallback((currentIndex, bottomSheet) => {
        if (currentIndex) {
            bottomSheet?.collapse();
        }
        else {
            bottomSheet?.expand();
        }
    }, []);
    return {
        snapPoints,
        onSheetChange,
        onToggleSheet,
        playing,
    };
};
//# sourceMappingURL=usePlayerUtils.js.map